import React from 'react'
import Card from './Card'
import classNames from 'classnames'
import Dropdown from './Dropdown'
import BtnIcon from './BtnIcon'
import { ReactSVG } from 'react-svg'
import { AxiosRequestConfig } from 'axios'
import { FieldValues, useForm, UseFormReturn } from 'react-hook-form'
import Btn from './Btn'
import { useAxios } from '../hooks/useAxios'
import { toast } from 'react-toastify'

interface Props {
  renderView: (item: any) => React.ReactElement | string
  className?: string
  item: any
  onDelete?: (id: string) => void
  updateMethod: (id: string, data: any) => AxiosRequestConfig
  updateSuccessText?: string
  renderUpdate: (
    form: UseFormReturn<FieldValues, any>
  ) => React.ReactElement | string
  onUpdate?: (item: any) => void
}

const InformationItem: React.FC<Props> = ({
  className = '',
  renderView,
  item,
  onDelete,
  updateMethod,
  updateSuccessText = 'Успешно',
  renderUpdate,
  onUpdate
}) => {
  const [mode, setMode] = React.useState<'view' | 'edit'>('view')
  const form = useForm({
    defaultValues: item
  })
  const { fire, loading } = useAxios()

  const onSubmit = async (data: any) => {
    const { response, error } = await fire(updateMethod(item.id, data))

    if (error) {
      toast.error(error.message)
    } else {
      toast.success(updateSuccessText)
      setMode('view')

      const data = response?.data ?? {}
      onUpdate?.(data)
    }
  }

  return (
    <Card className={classNames('information-item', className)}>
      {mode === 'view' ? (
        <div className={'information-item__inner'}>
          <div className={'information-item__content'}>{renderView(item)}</div>
          <div className={'information-item__actions'}>
            <Dropdown
              trigger={(open) => {
                return (
                  <BtnIcon onClick={open} filled>
                    <ReactSVG
                      wrapper={'span'}
                      src={'/i/svg/dots-vertical.svg'}
                    ></ReactSVG>
                  </BtnIcon>
                )
              }}
              render={(close) => {
                return (
                  <Card
                    className={classNames(
                      'information-item__dropdown-card',
                      'dropdown-menu'
                    )}
                    size={'sm'}
                  >
                    <ul>
                      <li>
                        <button
                          onClick={async () => {
                            await close()
                            setMode('edit')
                          }}
                          type={'button'}
                        >
                          Редактировать
                        </button>
                      </li>
                      <li>
                        <button
                          type={'button'}
                          onClick={async () => {
                            await close()
                            onDelete?.(item.id)
                          }}
                        >
                          Удалить
                        </button>
                      </li>
                    </ul>
                  </Card>
                )
              }}
            ></Dropdown>
          </div>
        </div>
      ) : (
        <>
          <header className={'card-head text-h3'}>Редактировать</header>
          <form
            onSubmit={form.handleSubmit(onSubmit)}
            className={'card-content'}
          >
            {renderUpdate(form)}

            <div className={'mt-md-8 mt-sm-6 u-flex u-flexAlignItemsCenter'}>
              <Btn
                loading={loading}
                disabled={loading || !form.formState.isDirty}
                type={'submit'}
              >
                Cохранить
              </Btn>
              <Btn
                className={'ml-md-5 ml-sm-4'}
                outlined
                onClick={() => {
                  setMode('view')
                  form.reset()
                }}
              >
                Отмена
              </Btn>
            </div>
          </form>
        </>
      )}
    </Card>
  )
}

export default InformationItem
